import { Box, Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { repositoryPos } from "../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

interface MessageResponse<T> {
  success: boolean;
  data: T;
}

interface DeleteProduct {
  PIds: string;
  onSearch: () => void;
}

const DeleteTicket = ({ PIds, onSearch }: DeleteProduct) => {
  const handleDeleteTicket = async () => {
    try {
      const response = await repositoryPos.post<MessageResponse<any>>(
        "/api/v1/TblMfgProductOrder/delete",
        { ids: [PIds] }
      );

      if (response && response.success) {
        NotificationExtension.Success("Xóa thành công");
        setTimeout(() => {
          modals.closeAll();
          onSearch();
        }, 1000);
      } else {
        NotificationExtension.Fails("Xóa thất bại");
      }
    } catch (error) {
      NotificationExtension.Fails("Có lỗi xảy ra khi xóa");
    }
  };

  return (
    <Box size={"auto"}>
      <Text size="20px" mt={5}>
        Bạn có chắc chắn muốn xóa phiếu này ?
      </Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="gray"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Thoát
        </Button>
        <Button
          type="button"
          color="red"
          onClick={handleDeleteTicket}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
      </Group>
    </Box>
  );
};

export default DeleteTicket;
